import { render } from "./Ontwikkeling.vue?vue&type=template&id=7249d550&scoped=true&ts=true"
import script from "./Ontwikkeling.vue?vue&type=script&lang=ts"
export * from "./Ontwikkeling.vue?vue&type=script&lang=ts"

import "./Ontwikkeling.vue?vue&type=style&index=0&id=7249d550&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7249d550"]])

export default __exports__